var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cstm-button",class:{dark: _vm.dark, black: _vm.black, block: _vm.block, small: _vm.size == 'small'}},[_c('button',{on:{"click":() => _vm.$emit('click')}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon)?_c('img',{attrs:{"src":_vm.icon,"alt":"icon"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }